import { Factory } from '@infodata-group/inf-commons';
import { Account } from '../account';

export class AccountFactory implements Factory<Account> {
  build(o: any): Account {
    return new Account(o.id, o.label);
  }

  getApi(): string {
    return 'dos';
  }
}
